const colors = {
  // TODO/HINT REMOVER Cores projeto anterior
  whiteBackground: "#FFFFFF",
  grayBackground: "#8D9B9C",

  disabled: "#D2D2D2",

  whitefashing: "#EEEEEE",
  platinum: "#E0E0E0",
  inputGray: "#E9E9E9",
  black: "#24272A",
  grayDim: "#626B6D",
  outerSpace: "#4D585A",
  blue: "#0C396D",
  neonBlue: "#3D69FF",
  uclaBlue: "#3978BE",
  lightGray: "#00000054",

};

export default colors;
